'use client';

import {
  getConferenceChatAuthApiBySite,
  openConferenceChatEntry,
} from '../../navbar/conferenceChat';
import type { ConferenceSite } from './types';
import styles from './ConferenceChatFloatingEntry.module.css';

interface ConferenceChatFloatingEntryProps {
  site: ConferenceSite;
}

function ConferenceChatIcon() {
  return (
    <svg
      aria-hidden="true"
      className={styles.icon}
      width="20"
      height="17"
      viewBox="0 0 20 17"
      fill="none"
    >
      <path
        d="M0 1.6C0 0.716346 0.716344 0 1.6 0H18.4C19.2837 0 20 0.716344 20 1.6V12.4488C20 13.3324 19.2837 14.0488 18.4 14.0488H3.74073C3.55995 14.0488 3.3845 14.11 3.24297 14.2225L0 16.8V1.6Z"
        fill="#4775E7"
      />
      <circle cx="5.2" cy="6.80156" r="1.2" fill="#EBF1FF" />
      <circle cx="9.99687" cy="6.80156" r="1.2" fill="#EBF1FF" />
      <circle cx="14.8016" cy="6.80156" r="1.2" fill="#EBF1FF" />
    </svg>
  );
}

// ConferenceChatFloatingEntry 对应 S 大会 PC 设计稿里的固定会聊入口；移动端不展示。
export default function ConferenceChatFloatingEntry({
  site,
}: ConferenceChatFloatingEntryProps) {
  const authApi = getConferenceChatAuthApiBySite(site);
  const label = site === 'en' ? 'Chat' : '会聊';

  return (
    <button
      type="button"
      className={styles.floatingEntry}
      onClick={() => {
        // 固定会聊入口始终展示，点击后按当前站点接口鉴权并在无权限时提示。
        // PC 固定入口按设计要求新开标签页进入会聊，避免打断当前大会浏览上下文。
        void openConferenceChatEntry({ authApi, site, openInNewTab: true });
      }}
      aria-label={label}
    >
      <ConferenceChatIcon />
      <span className={styles.label}>{label}</span>
    </button>
  );
}
